import { render } from "./SettingsBody.vue?vue&type=template&id=dcaa7cde&scoped=true"
import script from "./SettingsBody.vue?vue&type=script&lang=js"
export * from "./SettingsBody.vue?vue&type=script&lang=js"

import "./SettingsBody.vue?vue&type=style&index=0&id=dcaa7cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcaa7cde"]])

export default __exports__